import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, PLATFORM_ID, Renderer2, RendererFactory2 } from '@angular/core';
import { Observable, Subscription, takeUntil } from 'rxjs';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { commonService } from './core/services/common.service';
import { ICompanyInfo } from './site/feature-modules/welcome/models/welcome.models';
import { ComponentBase } from './core/base/common-base';
import { WelcomeService } from './site/feature-modules/welcome/services/welcome.service';
import { ItemPlace } from './site/shared-components/item-location-overlay/models/model';
import { IBranch } from './site/feature-modules/search-branch/models/branch.model';
import tinycolor from 'tinycolor2';
import { PagesConfig } from './core/defines/pages.config';
import { Router } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { ProfileService } from './site/feature-modules/profile/services/profile.service';
import { LocalStorageService } from 'src/locallocalStorage.service';
import { Store } from '@ngxs/store';
import { GetCompanyInfo } from './core/store/companyInfo/company-info.action';
import { CompanyInfoState } from './core/store/companyInfo/company-info-state';
import { LoadClientDetails } from './core/store/clientDetails/client-details.action';
import { GetBranches, SetSelectedBranch } from './core/store/branch/branch.action';
import { AddPlace } from './core/store/place/place.action';
import { IUserCart } from './core/models/user-cart.model';
import { GetCart } from './core/store/cart/cart.action';
import { CartState } from './core/store/cart/cart.state';
import { RateCompanyComponent } from './site/feature-modules/rate-company/rate-company.component';
import { UserCartService } from './site/feature-modules/home/shared/services/user-cart.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent extends ComponentBase implements OnInit {
  loading: boolean;
  error: boolean;
  companyInfo: ICompanyInfo;
  itemPlace: ItemPlace;
  branch: IBranch | null = null;
  changeLangSubscription = new Subscription();
  cart: IUserCart | null = null;
  // @Select(CompanyInfoState.getCompanyInfo) companyInfo$!: Observable<ICompanyInfo[]>;
  constructor(
    private router: Router,
    private profileService: ProfileService,
    private config: PrimeNGConfig,
    private welcomeService: WelcomeService,
    private translate: TranslateService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    public common: commonService,
    public rendererFactory: RendererFactory2,
    private cdr: ChangeDetectorRef,
    private localStorageService: LocalStorageService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private store: Store,
    private userCartService : UserCartService,
    private modalService : NgbModal
  ) {
    super();
    this.renderer = rendererFactory.createRenderer(null, null);
    this.changeLangSubscription = this.translate.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (event: LangChangeEvent) => {
          console.log('yyyyyyyyyyyyyyyyyyyyy',event.lang);
          this.localStorageService.setItem('lang', event.lang);
          const dir = event.lang === 'en' ? 'ltr' : 'rtl';
          this.renderer.setAttribute(document.documentElement, 'lang', event.lang);
          this.renderer.setAttribute(document.documentElement, 'dir', dir);
        }
      );
  }


  ngOnInit(): void {
    this.setCompanyIdentifier();
    // this.common.loading$.pipe(takeUntil(this.destroy$)).subscribe((loading) => {
    //   this.loading = loading;
    //   this.cdr.detectChanges();
    // });
    // this.common.error$.pipe(takeUntil(this.destroy$)).subscribe((error) => {
    //   this.error = error;
    //   this.cdr.detectChanges();
    // });
    if (this.common.isLoggedIn()) {
      this.store.dispatch(new LoadClientDetails());
      this.store.dispatch(new GetCart()).subscribe(() => {
        this.getCart();
      })
    }
  }

  // setDefaultBranch(): void {
  //   this.common.setBranch({
  //     id: this.companyInfo.mainBranch.id,
  //     name: this.translate.currentLang == 'en' ? this.companyInfo.mainBranch.nameEn : this.companyInfo.mainBranch.nameAr,
  //     address: '',
  //     isMainBranch: false,
  //     logo: '',
  //     place: this.companyInfo.config.items.itemPlace,
  //     googleMapsLink: '',
  //     city: {
  //       id: 0,
  //       name: '',
  //     },
  //   });
  // }
  private parseSubdomain(url: string): string {
    const parts: string[] = url.split('.');
    return parts.length > 2 || parts[1] == 'localhost' ? parts[0] : `${parts[0]}.${parts[1]}`;
  }

  setCompanyIdentifier() {
    const hostname: string = this.document.location.hostname;
    const companyIdentifier = this.parseSubdomain(hostname);
    // const companyIdentifier = 'yourechic';

    let oldCompanyIdentifier = this.common.getCompanyIdentifier();

    if (companyIdentifier !== oldCompanyIdentifier) {
      this.common.setCompanyIdentifier(companyIdentifier);
      this.common.clearBranch();
    }
    this.store.dispatch(new GetCompanyInfo()).subscribe(() => {
      this.store.select(CompanyInfoState.getCompanyInfo).subscribe((response) => {
        if (response) {
          this.companyInfo = response;
          // set branch and place
          if (
            this.companyInfo.config.catalogue.itemPlace == ItemPlace.Home ||
            this.companyInfo.config.catalogue.itemPlace == ItemPlace.OnSite
          ) {
            this.fetchBranches(this.companyInfo.config.catalogue.itemPlace);
          } else {
            this.fetchBranches(ItemPlace.OnSite);
          }

          // primary color
          this.setCSSVariable(
            '--color-primary',
            // response.config.identity.design.color ?? '#694ed6'
            '#694ed6'
          );
          this.updatePrimaryColor(
            // response.config.identity.design.color ?? '#694ed6'
            '#694ed6'
          );


          // default language
          // const lang: string = this.localStorageService.getItem('lang') ?? response.config.identity.design.defaultLanguage;
          const lang: string = this.localStorageService.getItem('lang') ?? 'en';
          this.localStorageService.setItem('lang', lang);
          this.translate.use(lang);
          this.translate.get('primeng').subscribe(res => {
            this.config.setTranslation(res);
          });


          // google analytics and facebook pixel
          // this.loadScriptTag(response.config. marketing.googleAnalyticsScript);
          // this.loadScriptTag(response.config.marketing.facebookPixelScript);
        }
        // this.setDefaultBranch();
        setTimeout(() => {
          let loader = this.renderer.selectRootElement('#loader')
          const body = this.document.getElementsByTagName("body");
          this.renderer.setStyle(loader, 'display', 'none')
          body[0].style.overflowY = 'scroll'
        }, 2500)
      });
    });
  }
    checkRating(): void {
    this.userCartService.checkRating().subscribe((res) => {
      if (res.data) {
        this.openRatingModal(res.data);
      }
    });
  }
  openRatingModal(id: number) {
    const modalRef = this.modalService.open(RateCompanyComponent, {
      centered: true,
      backdrop: 'static',
    });
    modalRef.componentInstance.id = id;
  }
  getCart() {
    this.store.select(CartState.cart).subscribe((cart) => {
      this.cart = cart
    })
  }
  selectedBranchById(id: number) {
    this.store.dispatch(new SetSelectedBranch(id));
  }
  addPlace(place: ItemPlace) {
    this.store.dispatch(new AddPlace(place));
  }
  fetchBranches(place: ItemPlace) {
    this.store.dispatch(new GetBranches(place)).subscribe(() => {
      this.addPlace(place);
      // set selected branch
      this.selectedBranchById(this.companyInfo.mainBranch.id);
    });
  }
  // getCompanyInfo() {
  //   // this.common.loading$.next(true);
  //   this.welcomeService
  //     .getCompanyInfo()
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe({
  //       next: (response) => {
  //         this.companyInfo = response.data;
  //         if (response.data) {
  //           // set branch and place
  //           if (
  //             this.companyInfo?.config.items.itemPlace == ItemPlace.Home ||
  //             this.companyInfo?.config.items.itemPlace == ItemPlace.OnSite
  //           ) {
  //             this.addPlace(this.companyInfo.config.items.itemPlace);
  //           }
  //           // primary color
  //           this.setCSSVariable(
  //             '--color-primary',
  //             response.data?.config.identity.design.color ?? '#694ed6'
  //           );
  //           this.updatePrimaryColor(
  //             response.data?.config.identity.design.color ?? '#694ed6'
  //           );


  //           // default language
  //           const lang: string = this.localStorageService.getItem('lang') ?? response.data.config.identity.design.defaultLanguage;
  //           this.localStorageService.setItem('lang', lang);
  //           this.translate.use(lang);
  //           this.translate.get('primeng').subscribe(res => {
  //             this.config.setTranslation(res);
  //           });


  //           // google analytics and facebook pixel
  //           this.loadScriptTag(response.data.config.marketing.googleAnalyticsScript);
  //           this.loadScriptTag(response.data.config.marketing.facebookPixelScript);
  //         }
  //         // this.itemPlace = this.common.getItemPlace();
  //         // this.branch = this.common.getBranch();
  //         // this.common.companyInfo$.next(response.data);
  //         // if (isPlatformBrowser(this.platformId)) {
  //         //   setTimeout(()=>{
  //         //     let loader = this.renderer.selectRootElement('#loader')
  //         //     const body = this.document.getElementsByTagName("body");
  //         //     this.renderer.setStyle(loader, 'display', 'none')
  //         //     body[0].style.overflowY = 'scroll'
  //         //   },1500)
  //         // }
  //       },
  //       error: (err) => {
  //         if (err.status == 404)
  //           return this.router.navigate([PagesConfig.notFound404]);
  //         return this.common.loading$.next(false);
  //       },
  //     });
  // }
  setCSSVariable(variable: string, value: string): void {
    document.documentElement.style.setProperty(variable, value);
  }

  updatePrimaryColor(baseColor: string): void {
    const color = tinycolor(baseColor);
    const variations: any = {
      '50': color.clone().lighten(50).toHexString(),
      '100': color.clone().lighten(40).toHexString(),
      '200': color.clone().lighten(30).toHexString(),
      '300': color.clone().lighten(20).toHexString(),
      '400': color.clone().lighten(10).toHexString(),
      '500': color.clone().toHexString(),
      '600': color.clone().darken(10).toHexString(),
      '700': color.clone().darken(20).toHexString(),
      '800': color.clone().darken(30).toHexString(),
      '900': color.clone().darken(40).toHexString(),
      '950': color.clone().darken(50).toHexString(),
    };

    Object.keys(variations).forEach((key) => {
      this.setCSSVariable(`--color-primary-${key}`, variations[key]);
    });
  }


  loadScriptTag(script: string) {
    let scripts = this.extractScriptsAndNoScripts(script);
    scripts.scripts.forEach((scriptContent) => {
      this.loadScript(scriptContent);
    });
    scripts.noScripts.forEach((noScriptContent) => {
      this.loadNoScript(noScriptContent);
    });
  }

  loadScript(scriptContent: string) {
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.text = scriptContent;
    this.renderer.appendChild(document.body, script);
  }

  loadNoScript(noScriptContent: string) {

    const noScript = this.renderer.createElement('noscript');
    noScript.text = noScriptContent;
    this.renderer.appendChild(document.body, noScript);
  }


  extractScriptsAndNoScripts(script: string): { scripts: string[], noScripts: string[] } {
    const scriptContents: string[] = [];
    const noScriptContents: string[] = [];

    const scriptRegex = /<script[^>]*>([\s\S]*?)<\/script>/gi;
    const noScriptRegex = /<noscript[^>]*>([\s\S]*?)<\/noscript>/gi;

    let match;

    while ((match = scriptRegex.exec(script)) !== null) {
      if (match[1]) {
        scriptContents.push(match[1].trim());
      }
    }

    while ((match = noScriptRegex.exec(script)) !== null) {
      if (match[1]) {
        noScriptContents.push(match[1].trim());
      }
    }

    return { scripts: scriptContents, noScripts: noScriptContents };
  }

}
